import React from 'react';
import clsx from 'clsx';

type Props<T> = {
    label: string | React.ReactNode;
    value: T;
    activeValue: T;
    inactiveValue: T;
    onChange: (value: T) => void;
    title?: string;
};

export default class ToggleButton<T> extends React.Component<Props<T>> {
    render() {
        const btnBase = "px-3 py-[5px] rounded-[5px] cursor-pointer text-[11px] font-medium transition-all duration-150 font-sans border border-slate-200 dark:border-transparent";
        const btnToggleOn = clsx(btnBase, "bg-accent-teal-light dark:bg-accent-muted text-teal-700 dark:text-accent/90 border-accent-teal dark:border-transparent ml-1.5");
        const btnToggleOff = clsx(btnBase, "bg-slate-100 dark:bg-white/[0.06] text-slate-400 dark:text-white/50 ml-1.5");

        const { label, value, activeValue, inactiveValue, onChange, title } = this.props;
        const isActive = value === activeValue;

        return (
            <button
                className={isActive ? btnToggleOn : btnToggleOff}
                onClick={() => onChange(isActive ? inactiveValue : activeValue)}
                title={title}
            >
                {label}
            </button>
        );
    }
}
